import { getCurrentInstance } from "vue";

/**
 * Montant entier au format français (« 12 345 »), sûr en SSR. Les milliers sont séparés par une
 * espace insécable classique : Bebas Neue n'a pas l'espace fine insécable d'Intl (U+202F).
 */
export const formatAmount = (value: number): string =>
    new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 })
        .format(Math.round(value))
        .replace(/[\u202f\u00a0]/g, "\u00a0");

/**
 * Hook pour utiliser les filtres globaux avec fallback SSR-safe
 */
export const useFilters = () => {
    const app = getCurrentInstance();
    const $filters = app?.appContext.config.globalProperties.$filters;

    const formatCurrency = (value: number, strict: boolean = true): string => {
        if (!$filters) {
            return new Intl.NumberFormat("fr-FR", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 0,
            }).format(value);
        }
        return $filters.currency(value, strict);
    };

    const formatNumber = (value: number): string => {
        if (!$filters) {
            return new Intl.NumberFormat("fr-FR").format(value);
        }
        return String($filters.number(value));
    };

    return {
        formatCurrency,
        formatNumber,
        formatAmount,
        // Expose l'objet filters original pour d'autres usages si nécessaire
        $filters,
    };
};
